import type { EngForm } from "../submissions/schema";
import type { TicketType } from "../submissions/types";

export const JIRA_ISSUE_TYPE = "Task";
export const TITLE_PREFIX = "PET - ";

// The VS board has no "Medium" priority, and Urgent has no Jira equivalent of its own.
const PRIORITIES: Record<EngForm["severity"], string> = {
  Urgent: "High",
  High: "High",
  Medium: "Normal",
  Low: "Low",
};

export const priorityFor = (severity: EngForm["severity"]): string => PRIORITIES[severity];

export const itypeFor = (ticketType: TicketType): string => (ticketType === "Bug" ? "BUG" : "Customer Fix");

export const FIELD_NAMES = { itype: "IType", team: "Engineering Team" } as const;
